import axiosInstance from "../../../axiosInstance";

export const submitContactForm = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/api/v1/users/home/contact-us",
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
